$(function() {
  $(document).on('click', '.load-more__cta', function(e) {
    e.preventDefault();
    $('.load-more--hidden, .load-more__pagination').removeClass('load-more--hidden');
    $(this).remove();
  });
});
